/**
 * 360 Resto Wordmark — Apple-style refined logotype.
 *
 * Aesthetic: minimalist, premium, smart. Inspired by Apple's product logotypes:
 *   - Tight letter-spacing on "Resto" (sentence-case, weighted body type, NOT all-caps Bebas)
 *   - "360" in a clean monospace numeral, slightly smaller
 *   - A 0.5px hairline divider between them
 *   - No emoji, no badges, no glow — pure typography
 *
 * Props:
 *   - variant: "nav" | "sidebar" | "hero"
 *   - tone: "dark" (text on light bg) | "light" (text on dark bg)
 *   - className: optional extra classes
 */
const Resto360Wordmark = ({
  variant = 'nav',
  tone = 'dark',
  className = '',
  ...rest
}) => {
  const sizing = {
    nav: { num: '13px', word: '17px', gap: 'gap-2', hairline: 12, hairlineThickness: 0.5 },
    sidebar: { num: '12px', word: '15px', gap: 'gap-1.5', hairline: 10, hairlineThickness: 0.5 },
    hero: { num: '18px', word: '28px', gap: 'gap-2.5', hairline: 18, hairlineThickness: 1 },
  }[variant];

  const numColor = tone === 'dark' ? '#86868B' : 'rgba(255,255,255,0.55)';
  const wordColor = tone === 'dark' ? '#1D1D1F' : '#FFFFFF';
  const hairlineColor = tone === 'dark' ? 'rgba(0,0,0,0.16)' : 'rgba(255,255,255,0.30)';

  return (
    <div
      className={`inline-flex items-center ${sizing.gap} ${className}`}
      data-testid="resto360-wordmark"
      {...rest}
    >
      <span
        className="leading-none"
        style={{
          fontFamily: "ui-monospace, 'SF Mono', 'IBM Plex Mono', monospace",
          fontWeight: 500,
          fontSize: sizing.num,
          color: numColor,
          letterSpacing: '0.02em',
          fontFeatureSettings: '"tnum" 1',
        }}
      >
        360
      </span>
      <span
        aria-hidden
        className="block"
        style={{
          width: sizing.hairline,
          height: sizing.hairlineThickness,
          background: hairlineColor,
        }}
      />
      <span
        className="leading-none"
        style={{
          fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Manrope', 'Inter', sans-serif",
          fontWeight: 600,
          fontSize: sizing.word,
          color: wordColor,
          letterSpacing: '-0.015em',
        }}
      >
        Resto
      </span>
    </div>
  );
};

export default Resto360Wordmark;
